import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export const DefaultFontSize = {
  admin: '0.75rem', // 12px
  customer: '0.875rem' // 14px
}
const DefaultTheme = {
  primitive: {
    blue: {
      50: '#e3e6f2',
      100: '#b4bad9',
      200: '#848dc0',
      300: '#5461a7',
      400: '#2e418b',
      500: '#232f5d', // Primary color
      600: '#01b0e0', // Accent/Secondary color
      700: '#09647d',
      800: '#12183b',
      900: '#0c102f',
      950: '#080b25'
    }
  },
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}'
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}'
        },
        mask: {
          background: 'rgba(0,0,0,0.4)',
          color: '{surface.200}'
        },
        formField: {
          background: '{surface.0}',
          disabledBackground: '{surface.200}',
          filledBackground: '{surface.50}',
          filledFocusBackground: '{surface.50}',
          borderColor: '{blue.500}',
          hoverBorderColor: '{surface.400}',
          focusBorderColor: '{primary.color}',
          invalidBorderColor: '{red.400}',
          color: '{surface.700}',
          disabledColor: '{surface.500}',
          placeholderColor: '{surface.500}',
          floatLabelColor: '{surface.500}',
          floatLabelFocusColor: '{surface.500}',
          floatLabelInvalidColor: '{red.400}',
          iconColor: '{surface.400}',
          shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)'
        },
        text: {
          color: '{surface.700}',
          hoverColor: '{surface.800}',
          mutedColor: '{surface.500}',
          hoverMutedColor: '{surface.600}'
        },
        list: {
          option: {
            focusBackground: '{surface.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}'
            }
          },
          optionGroup: {
            background: 'transparent',
            color: '{text.muted.color}'
          }
        }
      }
    }
  }
}

export const CustomerPreset = definePreset(Aura, {
  ...DefaultTheme
})

export const AdminPreset = definePreset(Aura, {
  ...DefaultTheme,
  components: {
    button: {
      paddingX: '8px',
      paddingY: '5px'
    },
    inputtext: {
      paddingX: '8px',
      paddingY: '5px',
      borderRadius: '4px'
    },
    inputgroup: {
      borderRadius: '4px'
    },
    select: {
      borderRadius: '4px',
      sm: {
        paddingX: '6px',
        paddingY: '2px'
        // fontSize: DefaultFontSize.admin
      },
      option: {
        padding: '4px 12px'
      }
    },
    breadcrumb: {
      padding: '5px'
    },
    tabs: {
      tab: {
        color: '{primary.500}',
        hoverColor: '{primary.500}',
        padding: '10px 14px 8px 14px',
        margin: '0 5px 0 0',
        hoverBackground: '{primary.100}',
        activeBackground: '{primary.500}',
        activeColor: 'white',
        background: '{primary.50}',
        fontWeight: '500'
      },
      activeBar: {
        height: '0px'
      }
    },
    datatable: {
      header: {
        padding: '5px 0px'
      },
      headerCell: {
        padding: '3px 5px'
      },
      bodyCell: {
        padding: '3px 5px'
      },
      row: {
        selectedBackground: '#c9e0f9',
        selectedColor: 'black'
      }
    },
    multiselect: {
      'option.padding': '5px',
      'list.header.padding': '5px 10px',
      paddingX: '5px',
      paddingY: '5px'
    },
    checkbox: {
      height: '16px',
      width: '16px'
    },
    contextmenu: {
      'item.padding': '5px'
    },
    message: {
      // 'text.fontSize': DefaultFontSize.admin
      colorScheme: {
        light: {
          info: {
            background: '#b5e5fa',
            borderColor: '#86d1f3',
            color: '#0b272e'
          }
        }
      }
    },
    dialog: {
      header: {
        padding: '1.25rem 1.25rem 0rem 1.25rem'
      }
    },
    stepper: {
      stepNumber: {
        activeColor: 'white',
        activeBackground: '{primary.500}'
      }
    },
    tree: {
      node: {
        selectedBackground: '#c9e0f9',
        selectedColor: 'black'
      },
      nodeIcon: {
        color: 'red',
        hoverColor: 'red',
        selectedColor: 'red'
      }
    },
    tag: {
      // fontSize: DefaultFontSize.admin
    },
    toast: {
      summary: {
        // fontSize: DefaultFontSize.admin
      },
      text: {
        gap: '2px'
      }
    }
  }
})
